module.exports = __webpack_public_path__ + "static/media/homepage2.6f945da8.svg";